<template>
  <div id="workshop-detail-tab-id" class="pt-dtl-tab-bg">
    <div>
      <b-card no-body class="custom-tab mb-4">
        <b-tabs card lazy>
          <b-tab
            title="Overview"
            @click.prevent="setDetailCurrentTab('overview_workshop', 'workshop-detail-tab-id', datas.description)"
            :active="getDetailActiveTab === 'overview_workshop'"
          >
            <overview-tab-section :data="datas"/>
          </b-tab>
          <b-tab
            title="Workshop Funding & Logistics"
            @click.prevent="setDetailCurrentTab('logistics_workshop', 'workshop-detail-tab-id')"
            :active="getDetailActiveTab === 'logistics_workshop'"
          >
            <workshop-logistics-tab-section :data="datas"/>
          </b-tab>
          <b-tab
            title="Speakers"
            @click.prevent="setDetailCurrentTab('workshop_speakers', 'workshop-detail-tab-id')"
            :active="getDetailActiveTab === 'workshop_speakers'"
          >
            <speaker :speakers="datas.speakers" v-if="datas.speakers.length > 0"/>
            <div class="text-muted regular-14" v-else>No result</div>
          </b-tab>
          <b-tab
            title="Schedule & Notes"
            @click.prevent="setDetailCurrentTab('schedule_notes', 'workshop-detail-tab-id')"
            :active="getDetailActiveTab === 'schedule_notes'"
          >
            <workshop-schedule-and-notes-tab-section />
          </b-tab>
          <b-tab
            title="Videos"
            @click.prevent="setDetailCurrentTab('videos_workshop', 'workshop-detail-tab-id')"
            :active="getDetailActiveTab === 'videos_workshop'"
          >
            <workshop-video-tab-section />
          </b-tab>
          <b-tab
            title="Workshop Participants"
            @click.prevent="setDetailCurrentTab('workshop_participants', 'workshop-detail-tab-id')"
            :active="getDetailActiveTab === 'workshop_participants'"
          >
            <div v-if="isAuthenticated">
              <workshop-participants-tab-section />
            </div>
            <div v-else>
              <div>
                <div class="box blur-content">
                  <!-- <workshop-participants-tab-section /> -->
                </div>
                <div class="overlay">
                  <signin :haltRedirect="true"/>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import OverviewTabSection from "./OverviewTabSection.vue"
import WorkshopParticipantsTabSection from "./WorkshopParticipantsTabSection.vue"
import WorkshopLogisticsTabSection from "./WorkshopLogisticsTabSection.vue"
import { mapGetters } from "vuex"
import Signin from "@/pages/Signin.vue"
//import DummyData from './dummy_data.json'
import WorkshopScheduleAndNotesTabSection from "./WorkshopScheduleAndNotesTabSection.vue"
import mixin from "@/utils/mixin.js"
import WorkshopVideoTabSection from "./WorkshopVideoTabSection.vue"
import Speaker from "@/components/CommonPages/Speaker.vue"

export default {
	name: "WorkshopTabsSection",
	components: {
		OverviewTabSection,
		WorkshopParticipantsTabSection,
		Signin,
		WorkshopLogisticsTabSection,
		WorkshopScheduleAndNotesTabSection,
		WorkshopVideoTabSection,
		Speaker,
	},
	mixins: [mixin],
	props: ["datas"],
	data() {
		return {
			tabs: [
				"#overview_workshop",
				"#logistics_workshop",
				"#schedule_notes",
				"#videos_workshop",
				"#workshop_participants",
				"#workshop_speakers",
			],
		}
	},
	mounted() {
		if (this.tabs.indexOf(this.$route.hash) !== -1) {
			const hashPath = this.$route.hash
			this.setDetailCurrentTab(hashPath.substring(1), "workshop-detail-tab-id")
		}
	},
	computed: {
		...mapGetters(["isAuthenticated", "getDetailActiveTab"]),
	},
}
</script>

<style scoped lang="scss">
.blur-content{
  -webkit-filter: blur(4px);
  -moz-filter: blur(4px);
  -o-filter: blur(4px);
  -ms-filter: blur(4px);
  filter: blur(4px);
}
.box {
  width: 100%;
  height: 100%;
  min-height: 5rem !important;
  position: absolute;
  opacity: 0.7;
  user-select: none;
  pointer-events: none;
  @media (max-width: 64rem) {
    display: none;
  }
}
</style>
